export interface ReservationRequestListFilters {
  status?: string;
  customer_name?: string;
  date_from?: string;
  date_to?: string;
  sort?: string;
  order?: string;
}

export interface ReservationListFilters {
  status?: string | string[];
  customer_name?: string;
  date_from?: string;
  date_to?: string;
  sort?: string;
  order?: string;
}

export const reservationRequestKeys = {
  all: ["reservationRequests"] as const,
  lists: () => [...reservationRequestKeys.all, "list"] as const,
  list: (filters: ReservationRequestListFilters) =>
    [...reservationRequestKeys.lists(), filters] as const,
  detail: (id: string) =>
    [...reservationRequestKeys.all, "detail", id] as const,
};

export const reservationKeys = {
  all: ["reservations"] as const,
  lists: () => [...reservationKeys.all, "list"] as const,
  list: (filters: ReservationListFilters) =>
    [...reservationKeys.lists(), filters] as const,
  detail: (id: string) => [...reservationKeys.all, "detail", id] as const,
};
